// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardLayout_wrapper__yggy4","main":"DashboardLayout_main__4tvpS","content":"DashboardLayout_content__G6EhG"};